// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xG8nh{display:flex;align-items:center}.F4ZT0{margin-inline-end:12px}.KcpdR{flex:1 0 auto;display:flex;flex-direction:column;max-width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `xG8nh`,
	"avatar": `F4ZT0`,
	"details": `KcpdR`
};
export default ___CSS_LOADER_EXPORT___;
